import localForage from 'localforage';
import { PostHogErrorBoundaryFallbackProps } from 'posthog-js/react';

import { Icon } from '~/modules/elements/akui/icon';
import { Menu } from '~/modules/elements/akui/menu';
import { MenuButton } from '~/modules/elements/menu';
import MenuWithLogo from '~/modules/elements/menu-with-logo';
import storage from '~/modules/utils/storage';

type Props = PostHogErrorBoundaryFallbackProps & {
  resetError: () => void;
};

export const ErrorFallback = ({ error, resetError }: Props) => {
  const message = typeof error === 'object' && error !== null && 'message' in error ? String(error.message) : null;

  return (
    <MenuWithLogo supportedBrowsers>
      <Menu.Header>
        <Icon icon="ic:baseline-warning" className="text-[2.1875rem]" /> An error occurred :(
      </Menu.Header>
      {message !== null ? (
        <>
          <span className="typography text-lg">The game crashed with following error</span>
          <pre className="text-default font-mono">{message}</pre>
        </>
      ) : (
        <span className="typography text-lg">The game crashed</span>
      )}
      <span className="typography text-lg">
        Help fix it by reporting what exactly has happened at{' '}
        <a href="https://github.com/Asvarox/allkaraoke" target="_blank" rel="noreferrer">
          GitHub
        </a>{' '}
        or{' '}
        <a href="https://www.facebook.com/allkaraoke.party" target="_blank" rel="noreferrer">
          Facebook
        </a>
      </span>
      <MenuButton onClick={resetError}>Reset Error</MenuButton>
      <Menu.HelpText>If that doesn&#39;t help</Menu.HelpText>
      <MenuButton onClick={() => (global.location.href = global.location?.origin)}>Reload the game</MenuButton>
      <Menu.HelpText>If that doesn&#39;t help</Menu.HelpText>
      <MenuButton
        onClick={() => {
          if (
            global.confirm(
              'Are you sure? It will delete all custom songs and scores. Before doing that, try opening the game in an private window or another browser to make sure it will actually help',
            )
          ) {
            storage.session.clear();
            storage.local.clear();
            localForage.clear();
            global.location.href = global.location?.origin;
          }
        }}>
        Clear all data
      </MenuButton>
    </MenuWithLogo>
  );
};
